import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["forwardedRef"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import { CustomPropTypes } from '@beef/react';
import { assertBooleanOrNull } from "../utils/assert";
import { allowParamOmit } from "../utils/decorators";
import withForwardedRef from "./withForwardedRef";
var withToggle = function withToggle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
    _ref2 = _slicedToArray(_ref, 3),
    _ref2$ = _ref2[0],
    isOpenProp = _ref2$ === void 0 ? 'isOpen' : _ref2$,
    _ref2$2 = _ref2[1],
    onOpenProp = _ref2$2 === void 0 ? 'onOpen' : _ref2$2,
    _ref2$3 = _ref2[2],
    onCloseProp = _ref2$3 === void 0 ? 'onClose' : _ref2$3;
  return function (WrappedComponent) {
    var _objectSpread2;
    var Toggleable = /*#__PURE__*/function (_React$Component) {
      _inherits(Toggleable, _React$Component);
      var _super = _createSuper(Toggleable);
      function Toggleable(props) {
        var _this;
        _classCallCheck(this, Toggleable);
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "handleOpen", function () {
          var onOpen = _this.props[onOpenProp];
          _this.setState(_defineProperty({}, isOpenProp, true));
          if (onOpen) onOpen();
        });
        _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
          var onClose = _this.props[onCloseProp];
          _this.setState(_defineProperty({}, isOpenProp, false));
          if (onClose) onClose();
        });
        assertBooleanOrNull(props[isOpenProp], 'constructor', "props.".concat(isOpenProp));
        _this.state = _defineProperty({}, isOpenProp, !!props[isOpenProp]);
        return _this;
      }
      _createClass(Toggleable, [{
        key: "render",
        value: function render() {
          var isOpen = this.state[isOpenProp];
          var _this$props = this.props,
            forwardedRef = _this$props.forwardedRef,
            otherProps = _objectWithoutProperties(_this$props, _excluded);
          return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, otherProps, {
            ref: forwardedRef
          }, _defineProperty({}, onOpenProp, this.handleOpen), _defineProperty({}, onCloseProp, this.handleClose), _defineProperty({}, isOpenProp, isOpen), {
            "data-t-id": "source-enhancers"
          }));
        }
      }]);
      return Toggleable;
    }(React.Component);
    Toggleable.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread(_objectSpread({}, WrappedComponent.propTypes), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, isOpenProp, PropTypes.bool), _defineProperty(_objectSpread2, onOpenProp, PropTypes.func), _defineProperty(_objectSpread2, onCloseProp, PropTypes.func), _defineProperty(_objectSpread2, "forwardedRef", CustomPropTypes.ref), _objectSpread2)) : {};

    /**
     * Override component name by prepending `Toggleable~`
     * to make it look nice, for example: `ToggleableComponent`
     */
    if (process.env.NODE_ENV !== 'production') {
      var WrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || '';
      Toggleable.displayName = "Toggleable".concat(WrappedComponentName);
    }
    return withForwardedRef(Toggleable);
  };
};
export default allowParamOmit(withToggle);